import { useEffect } from 'react';

function useClickOutside(ref, handler) {
  useEffect(() => {

    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        handler();
      }
    };

    // New function to handle the Escape key
    const handleEscapeKey = (event) => {
      if (event.key === 'Escape') {
        handler();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    // Add the keydown listener
    document.addEventListener('keydown', handleEscapeKey);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      // Remove the keydown listener on cleanup
      document.removeEventListener('keydown', handleEscapeKey);
    };
  }, [ref, handler]);
}

export default useClickOutside;